import React from 'react';
import { Logo } from './Logo';
import { Breadcrumbs, type BreadcrumbItem } from './Breadcrumbs';
interface HeaderProps {
  breadcrumbs?: BreadcrumbItem[];
  documentCount?: number;
  onLogout: () => void;
}
export function Header({
  breadcrumbs,
  documentCount,
  onLogout
}: HeaderProps) {
  return <header className="h-16 border-b border-navy-light bg-navy px-6 flex items-center justify-between shrink-0" data-id="element-21" data-mp="2nl3i1a51ekbg">
      <div className="flex items-center gap-4 min-w-0" data-id="element-22" data-mp="2rl46lnluobw8">
        <Logo size="md" data-id="element-23" data-mp="2rkb5b25nuelh" />

        {breadcrumbs && breadcrumbs.length > 0 && <>
            <div className="h-5 w-px bg-navy-light shrink-0" aria-hidden="true" data-id="element-24" data-mp="2wivzajubk21h" />
            <Breadcrumbs items={breadcrumbs} data-id="element-25" data-mp="31cqn9zgyj36d" />
            {documentCount !== undefined && <span className="text-sm text-gray-500 shrink-0" data-id="element-26" data-mp="36aa1x0hkhhyu">
                — {documentCount.toLocaleString()} documents
              </span>}
          </>}
      </div>

      <button onClick={onLogout} className="text-sm text-gray-400 hover:text-white transition-colors shrink-0 ml-4" data-id="element-27" data-mp="3fc9ixssl0m1s">
        Logout
      </button>
    </header>;
}